module.exports = __webpack_public_path__ + "assets/img/ant-nuosavo-namo-saules-elektrine.e09f9c33.webp";